function stepSetValidating({ state }) {
  state.set('client.registrationStep.validating', true)
}

export default stepSetValidating



// WEBPACK FOOTER //
// ./src/modules/login/actions/stepSetValidating.js